<div class="main-wrapper">
  @if (label()) {
    <label class="label" [for]="id()">{{ label() }}</label>
  }
  <p-password
    [class]="styleClass()"
    [feedback]="feedback()"
    [formControl]="control()"
    [inputId]="id()"
    [invalid]="this.control().touched && this.control().invalid"
    [placeholder]="placeholder()"
    [required]="required()"
    [toggleMask]="toggleMask()"
  />
@if (this.control().touched && this.control().invalid) {
  <p-message severity="error" size="small" variant="simple">
    {{ errorMessage() }}
  </p-message>
}
</div>
